export const avatarCustomizationOptions = [
    {
        label: "Arrière Plan",
        key: "avatarStyle",
        options: [
            { value: "Circle", label: "Cercle" },
            { value: "Transparent", label: "Transparent" }
        ]
    },
    {
        label: "Coiffure",
        key: "topType",
        options: [
            { value: "ShortHairShortFlat", label: "Courte Plate" },
            { value: "LongHairStraight", label: "Longue Lisse" },
            { value: "LongHairCurly", label: "Longue Bouclée" },
            { value: "ShortHairDreads01", label: "Courtes Dreadlocks" },
            { value: "ShortHairDreads02", label: "Courtes Dreadlocks 02" },
            { value: "LongHairBun", label: "Chignon Long" },
            { value: "Hat", label: "Chapeau" },
            { value: "Hijab", label: "Hijab" },
            { value: "Turban", label: "Turban" },
            { value: "ShortHairThemed", label: "Courte Thème" },
            { value: "LongHairMiaWallace", label: "Longue Mia Wallace" },
            { value: "ShortHairFrizzle", label: "Frisée Courte" },
            { value: "LongHairStraight2", label: "Longue Lisse 2" },
            { value: "ShortHairShortRound", label: "Courte Ronde" },
        ]
    },
    {
        label: "Accessoires",
        key: "accessoriesType",
        options: [
            { value: "Prescription02", label: "Lunettes de Prescription 02" },
            { value: "Sunglasses", label: "Lunettes de Soleil" },
            { value: "Blank", label: "Aucun" },
            { value: "Prescription01", label: "Lunettes de Prescription 01" },
            { value: "Round", label: "Lunettes Rondes" },
        ]
    },
    {
        label: "Couleur des Cheveux",
        key: "hairColor",
        options: [
            { value: "BrownDark", label: "Brun Foncé" },
            { value: "Blonde", label: "Blond" },
            { value: "Black", label: "Noir" },
            { value: "Red", label: "Rouge" },
            { value: "Blue", label: "Bleu" },
        ]
    },
    {
        label: "Type de Barbe",
        key: "facialHairType",
        options: [
            { value: "BeardLight", label: "Barbe Légère" },
            { value: "MoustacheFancy", label: "Moustache" },
            { value: "BeardMedium", label: "Barbe Moyenne" },
            { value: "Blank", label: "Aucune" },
            { value: "BeardMajestic", label: "Barbe Majestic" },
        ]
    },
    {
        label: "Type de Vêtement",
        key: "clotheType",
        options: [
            { value: "Hoodie", label: "Hoodie" },
            { value: "BlazerShirt", label: "Blazer" },
            { value: "ShirtCrewNeck", label: "T-Shirt Col Rond" },
            { value: "ShirtVNeck", label: "T-Shirt Col V" },
            { value: "Overall", label: "Salopette" },
        ]
    },
    {
        label: "Couleur des Vêtements",
        key: "clotheColor",
        options: [
            { value: "PastelBlue", label: "Bleu Pastel" },
            { value: "Gray01", label: "Gris" },
            { value: "Heather", label: "Gris Foncé" },
            { value: "Red", label: "Rouge" },
        ]
    },
    {
        label: "Yeux",
        key: "eyeType",
        options: [
            { value: "Happy", label: "Heureux" },
            { value: "Surprised", label: "Surpris" },
            { value: "Wink", label: "Clin d'œil" },
            { value: "Default", label: "Par Défaut" },
            { value: "Squint", label: "Plisser" },
            { value: "EyeRoll", label: "Roulade des Yeux" },
        ]
    },
    {
        label: "Sourcils",
        key: "eyebrowType",
        options: [
            { value: "Default", label: "Normal" },
            { value: "RaisedExcited", label: "Excité" },
            { value: "SadConcerned", label: "Préoccupé" },
            { value: "Angry", label: "En Colère" },
        ]
    },
    {
        label: "Bouche",
        key: "mouthType",
        options: [
            { value: "Smile", label: "Sourire" },
            { value: "Serious", label: "Sérieux" },
            { value: "Disbelief", label: "Incrédule" },
            { value: "Twinkle", label: "Éclat" },
            { value: "Grimace", label: "Grimace" },
            { value: "Sad", label: "Triste" },
        ]
    },
    {
        label: "Couleur de Peau",
        key: "skinColor",
        options: [
            { value: "Light", label: "Clair" },
            { value: "MediumLight", label: "Moyen Clair" },
            { value: "DarkBrown", label: "Foncé" },
            { value: "Black", label: "Noir" },
            { value: "Pale", label: "Pâle" },
        ]
    },
];

export const defaultAvatarOptions = {
    avatarStyle: 'Circle',
    topType: 'ShortHairShortFlat',
    accessoriesType: 'Prescription02',
    hairColor: 'BrownDark',
    facialHairType: 'BeardLight',
    clotheType: 'Hoodie',
    clotheColor: 'PastelBlue',
    eyeType: 'Happy',
    eyebrowType: 'Default',
    mouthType: 'Smile',
    skinColor: 'Light',
};